export function hitungDataInternet(
  bitrate: number,
  timestamp: string,
  hari: number
) {
  const { hours: jam, minutes: menit } = parseTime(timestamp);
  const {totalJam, totalMenit} = hitungJamMenit(jam, menit, hari);
  const totalDetik = (jam * 3600) + (menit * 60);
  const totalByte = (bitrate * totalDetik * hari) / 8;

  const isGB = totalByte >= 1_000_000;
  const satuanByte = isGB ? "GB" : "MB";
  const result = isGB ? totalByte / 1_000_000 : totalByte / 1_000;

  return {
    dataInternet: result.toLocaleString("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }),
    jam,
    menit,
    totalMenit,
    totalJam,
    bitrate,
    hari,
    satuanByte,
  };
}

function parseTime(time: string): { hours: number; minutes: number } {
  const colonIndex = time.indexOf(":");
  if (colonIndex === -1) return { hours: 0, minutes: 0 };

  const hours = Number(time.slice(0, colonIndex)) || 0;
  const minutes = Number(time.slice(colonIndex + 1)) || 0;

  return { hours, minutes };
}


// Mengubah "1000" menjadi "1.000"
export const toThousandSeparator = (value: string) => {
  const digits = value.replace(/\D/g, ""); // Hapus semua selain angka
  if (!digits) return "";
  return new Intl.NumberFormat("id-ID").format(parseInt(digits));
};

// Mengubah "1.000" kembali menjadi "1000" untuk kalkulasi
export const parseRawNumber = (value: any) => {

  return String(value).replaceAll(".", "");
};

function hitungJamMenit(jam: number, menit: number, hari: number): { totalJam: any; totalMenit: any; } {
  const totalMenit = ((jam * 60) + menit)*  hari;
  
  const totalJam = Math.floor(totalMenit / 60);
  const totalMenitSisa = totalMenit % 60;
  return {
    totalJam,
    totalMenit: totalMenitSisa,
  };
}
